import React, { useState } from "react";
import PropTypes from "prop-types";
import { Card, Grid } from "@mui/material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import CustomModal from "shared/components/MDmodal/CustomModal";
import { createUserService } from "modules/usuario/services/userService";
import FormJobOrder from "../Form/FormJobOrder";

const HeaderJobOrder = ({ children, onUserCreated }) => {
  const [open, setOpen] = useState(false);

  const handleCreate = async (data) => {
    const created = await createUserService(data);
    onUserCreated(created);
    setOpen(false);
  };

  return (
    <MDBox position="relative" sx={{ mt: -2, mx: -3, py: 2, px: -2 }}>
      <Card sx={{ mt: 1, mx: 3, py: 2, px: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between" spacing={3}>
          <Grid item>
            <MDTypography variant="h5" fontWeight="medium">
              Ordenes de Trabajo
            </MDTypography>
          </Grid>
        </Grid>
        {children}
      </Card>
      <CustomModal open={open} onClose={() => setOpen(false)} title="Crear Agendamiento">
        <FormJobOrder onSubmit={handleCreate} afterSubmit={() => {}} />
      </CustomModal>
    </MDBox>
  );
};

HeaderJobOrder.defaultProps = {
  children: "",
  onUserCreated: null,
};

HeaderJobOrder.propTypes = {
  children: PropTypes.node,
  onUserCreated: PropTypes.func,
};

export default HeaderJobOrder;
